export function parseWav32f(buf: ArrayBuffer): { channels: Float32Array[]; sample_rate: number } {
  const view = new DataView(buf);
  // Minimal RIFF parser; we only support 32-bit float WAV (format=3) — what D07 produces.
  const fmt = view.getUint16(20, true);
  if (fmt !== 3) throw new Error(`unsupported WAV format ${fmt}; expected 3 (IEEE float)`);
  const channelCount = view.getUint16(22, true);
  const sampleRate = view.getUint32(24, true);
  const dataLen = view.getUint32(40, true);
  const total = dataLen / 4 / channelCount;
  const channels: Float32Array[] = Array.from(
    { length: channelCount },
    () => new Float32Array(total),
  );
  let off = 44;
  for (let i = 0; i < total; i++) {
    for (let c = 0; c < channelCount; c++) {
      channels[c][i] = view.getFloat32(off, true);
      off += 4;
    }
  }
  return { channels, sample_rate: sampleRate };
}
